export default class {
  constructor () {
    this.rfc = process.env.VUE_APP_ENV_RFC

    this.state = {
      urlLogo: '',
      urlIcon: '',
      urlBackground: '',
      theme: '',
      isSFS: false,
      isHMM: false
    }

    this.rfcs = {
      'hmm': 'FOPI610609BT0',
      'sfs': 'SFS9511146S3',
      'sfn': 'SFN980513143',
      'mf': 'MME990526KS1'
    }

    this.rfcs_has_branch = [
      this.rfcs['hmm'],
      this.rfcs['sfn'],
      this.rfcs['mf']
    ]

    const globalSettings = {
      [this.rfcs['hmm']]: {
        urlLogo: require('@/assets/logos/hmm_logo.png'),
        urlIcon: require('../assets/icons/hmm_icon.png'),
        urlBackground: require('../assets/backgrounds/hmm_background.png'),
        theme: JSON.parse('{"theme":{"colors":{"primary":"#34276E","secondary":"#333333","success":"#0C9039","danger":"rgb(242,19,93)","warning":"#FF8200","dark":"#0D0D0D","gray":"#B9B4C0","pending":"#3861F5"}}}')
      },
      [this.rfcs['sfs']]: {
        urlLogo: require('@/assets/logos/sfs_logo.png'),
        urlIcon: require('../assets/icons/sfs_icon.png'),
        urlBackground: require('../assets/backgrounds/sfs_background.png'),
        theme: JSON.parse('{"theme":{"colors":{"primary":"#A34936","secondary":"#333333","success":"rgb(23, 201, 100)","danger":"rgb(242,19,93)","warning":"#FF8200","dark":"#0D0D0D","gray":"#EFEFEF","pending":"#3861F5"}}}')
      },
      [this.rfcs['sfn']]: {
        urlLogo: require('@/assets/logos/sfn_logo.png'),
        urlIcon: require('../assets/icons/sfn_icon.png'),
        urlBackground: require('../assets/backgrounds/sfn_background.png'),
        theme: JSON.parse('{"theme":{"colors":{"primary":"#A34936","secondary":"#333333","success":"rgb(23, 201, 100)","danger":"rgb(242,19,93)","warning":"#FF8200","dark":"#0D0D0D","gray":"#EFEFEF","pending":"#3861F5"}}}')
      },
      [this.rfcs['mf']]: {
        urlLogo: require('@/assets/logos/mf_logo.png'),
        urlIcon: require('../assets/icons/mf_icon.png'),
        urlBackground: require('../assets/backgrounds/mf_background.png'),
        theme: JSON.parse('{"theme":{"colors":{"primary":"#4D4D4B","secondary":"#333333","success":"#0C9039","danger":"rgb(242,19,93)","warning":"#FF8200","dark":"#0D0D0D","gray":"#B9B4C0","pending":"#3861F5"}}}')
      },
      default: {
        urlLogo: require('@/assets/logos/hmm_logo.png'),
        urlIcon: require('../assets/icons/hmm_icon.png'),
        urlBackground: require('../assets/backgrounds/hmm_background.png'),
        theme: JSON.parse('{"theme":{"colors":{"primary":"#654321","secondary":"#333333","success":"#0C9039","danger":"rgb(242,19,93)","warning":"#FF8200","dark":"#0D0D0D","gray":"#B9B4C0","pending":"#3861F5"}}}')
      }
    }

    const settings = {
      ...globalSettings[this.rfc] || globalSettings['default'],
      isSFS: this.rfc === this.rfcs['sfs'],
      isHMM: this.rfc === this.rfcs['hmm']
    }

    this.state = settings

    this.getters = {
      urlLogo: state => state.urlLogo,
      urlIcon: state => state.urlIcon,
      urlBackground: state => state.urlBackground,
      theme: state => state.theme,
      isSFS: state => state.isSFS,
      isHMM: state => state.isHMM
    }
  }
}
